/**
 * @file
 * Google Analytics.
 */

(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function gtag() {
    window.dataLayer.push(arguments);
  }

  gtag('js', new Date());
  gtag('config', 'G-ZYQ6Z1783Y');
})();
